import { TSize } from '../models'

export const getSizeMods = (styles: Record<string, string>, size?: TSize) => {
  return {
    [styles.sizeNormal]: size === 'normal',
    [styles.sizeSmall]: size === 'small',
  }
}
